export default "__VITE_ASSET__DGglqQwJ__"